module.exports = __webpack_public_path__ + "static/media/SizeBadOptimized.60dff43b.webp";